import { useParams } from '@tanstack/react-router';
import { createContext, useContext, useEffect, useState } from 'react';

export const SELECTED_LOOP_STORAGE_KEY = 'nexus-selected-loop-id';

const SelectedLoopContext = createContext<
  | {
      selectedLoopId: number | undefined;
      setSelectedLoopId: (id: number) => void;
    }
  | undefined
>(undefined);

export const SelectedLoopProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedLoopId, setSelectedLoopId] = useState<number | undefined>(() => {
    try {
      const stored = localStorage.getItem(SELECTED_LOOP_STORAGE_KEY);
      return stored ? Number(stored) : undefined;
    } catch {
      return undefined;
    }
  });

  const { loopId } = useParams({ strict: false }) as { loopId?: number };

  useEffect(() => {
    if (loopId) {
      setSelectedLoopId(loopId);
      localStorage.setItem(SELECTED_LOOP_STORAGE_KEY, String(loopId));
    }
  }, [loopId]);

  return (
    <SelectedLoopContext.Provider value={{ selectedLoopId, setSelectedLoopId }}>
      {children}
    </SelectedLoopContext.Provider>
  );
};

export const useSelectedLoop = () => {
  const context = useContext(SelectedLoopContext);
  if (!context) {
    throw new Error('useSelectedLoop must be used within SelectedLoopProvider');
  }
  return context;
};
